import React from 'react';
import { useSelector } from 'react-redux';

import { selectAddressByString } from '@r1-frontend/entities/ContactAddress/selectors/selectAddressByString';

import { btnSizes, btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';

import { DescribedListItem } from '~/src/features/full-buy/DescribedListItem';
import { TState } from '~/src/store';

import * as ST from './styled';

interface IConfirmedFormProps {
    isDisableBtn?: boolean,
    onEdit: () => void,
}

export const ConfirmedForm = ({ onEdit, isDisableBtn }: IConfirmedFormProps): JSX.Element => {
    const {
        addressStr,
    } = useSelector((state: TState) => ({
        addressStr: selectAddressByString(state),
    }));

    return (
        <ST.ConfirmedForm>
            <ST.ContactsList>
                <DescribedListItem
                    title={'Адрес подключения'}
                    value={addressStr}
                    imagePath={'/static/images/full-buy/address-icons/location.svg'}
                />
            </ST.ContactsList>

            <ST.Button
                type={btnTypes.SECONDARY}
                size={btnSizes.MIDDLE}
                onClick={onEdit}
                disabled={isDisableBtn}
            >
                Изменить
            </ST.Button>
        </ST.ConfirmedForm>
    );
};
